import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const ChangedFunction: HelperFunction = {
	tokenName: 'CHANGED',
	nodeType: functionNodeTypes.Changed,
	evaluate(node, evaluateExpr, context) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('CHANGED function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string') {
			return err(evaluatorErrorWithNode('CHANGED function argument must be a string', node))
		}
		return ok(context.getChangedInputCids().has(result.value))
	}
}
